<template>
  <div class="hero is-primary is-fullheight is-bold">
    <div class="hero-body">
      <div class="container">
        <login-signup-tabs></login-signup-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import LoginSignupTabs from '@/components/Login/LoginSignupTabs.vue'

export default {
  name: 'Login',
  components: {
    LoginSignupTabs
  },
}
</script>

<style scoped lang="scss">
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 600px;
}

.logo {
  font-size: 3rem;
}
</style>
